/* Zoektermen verbeteren. Overgenomen uit het hairwebshop-thema.

   Shopify zoekt letterlijk. "sampoo" levert niets op omdat er een letter mist,
   en "long strong" levert een zoekresultatenpagina op terwijl de bezoeker de
   lijnpagina bedoelt. Dit bestand legt de getypte tekst naast de namen die in
   deze winkel écht bestaan — merken, collecties en productsoorten uit
   snippets/zoek-woordenlijst.liquid — en kiest de juiste term.

   Alleen bij een duidelijke overeenkomst. Bij twijfel gebeurt er niets: een
   verkeerde correctie is erger dan geen correctie, want dan zoekt de winkel
   iets anders dan de bezoeker vroeg zonder dat hij weet waarom.

   Geeft twee dingen door aan de rest van het thema:
     window.ncZoekTerm(tekst)   de verbeterde term, of null
     window.ncZoekDoel(tekst)   een merk of collectie met een eigen pagina
*/

(function () {
  'use strict';

  /* Alles plat: kleine letters, geen accenten, geen apostrofs of streepjes.
     Daarmee is "loreal" hetzelfde als "L'Oréal" en "long strong" hetzelfde als
     "Long & Strong". */
  function plat(tekst) {
    return (tekst || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['’`´]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Aantal tikfouten tussen twee woorden. Damerau-Levenshtein, dus omgewisselde
     letters tellen als één beweging — "conditinoer" is één vergissing en geen
     twee. Stopt zodra het verschil te groot wordt; dan hoeft de rest van de
     tabel niet meer uitgerekend te worden. */
  function tikfouten(a, b, grens) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > grens) return grens + 1;

    var tweeTerug = null;
    var vorige = [];
    var huidige;
    var i, j;

    for (j = 0; j <= b.length; j++) vorige[j] = j;

    for (i = 1; i <= a.length; i++) {
      huidige = [i];
      var kleinste = i;
      for (j = 1; j <= b.length; j++) {
        var kosten = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var waarde = Math.min(vorige[j] + 1, huidige[j - 1] + 1, vorige[j - 1] + kosten);
        if (i > 1 && j > 1 && tweeTerug &&
            a.charAt(i - 1) === b.charAt(j - 2) &&
            a.charAt(i - 2) === b.charAt(j - 1)) {
          waarde = Math.min(waarde, tweeTerug[j - 2] + 1);
        }
        huidige[j] = waarde;
        if (waarde < kleinste) kleinste = waarde;
      }
      if (kleinste > grens) return grens + 1;
      tweeTerug = vorige;
      vorige = huidige;
    }
    return vorige[b.length];
  }

  /* Hoeveel tikfouten mogen er in? Bij korte woorden bijna niets, anders wordt
     "haar" ineens "haai" en "wax" ineens "was". */
  function toegestaan(woord, max) {
    if (woord.length <= 4) return 0;
    if (woord.length <= 7) return 1;
    return Math.min(2, max);
  }

  var lijst = {
    klaar: false,
    doelen: [],   // merken en collecties: die hebben een eigen pagina
    woorden: [],  // soorten en losse woorden: alleen om op te corrigeren
    regels: {},
    max: 2
  };

  function voorbereid() {
    if (lijst.klaar) return lijst;
    lijst.klaar = true;

    var bron = window.ncZoekLijst;
    if (!bron) return lijst;
    if (typeof bron.maxAfstand === 'number') lijst.max = bron.maxAfstand;

    /* Merken eerst, dan collecties: bij een gelijke naam wint het merk.

       Binnen de collecties wint bij een gelijke naam degene mét een eigen
       lijnpagina (de "s" uit de woordenlijst). De oude en de vernieuwde
       Keune-lijnen heten letterlijk hetzelfde; wie "silver savior" typt hoort
       op de vernieuwde te landen. */
    var op_plat = {};
    (bron.merken || []).forEach(function (m) {
      if (!m || !m.n) return;
      var doel = { naam: m.n, plat: plat(m.n), url: m.u || '', soort: 'merk' };
      lijst.doelen.push(doel);
      op_plat[doel.plat] = doel;
    });
    (bron.collecties || []).forEach(function (c) {
      if (!c || !c.n) return;
      var p = plat(c.n);
      var bestaand = op_plat[p];
      if (bestaand) {
        if (bestaand.soort === 'collectie' && c.s && !bestaand.s) {
          bestaand.naam = c.n;
          bestaand.url = c.u || '';
          bestaand.s = 1;
        }
        return;
      }
      var doel = { naam: c.n, plat: p, url: c.u || '', soort: 'collectie', s: c.s ? 1 : 0 };
      lijst.doelen.push(doel);
      op_plat[p] = doel;
    });
    (bron.soorten || []).forEach(function (naam) {
      if (naam) lijst.woorden.push({ naam: naam, plat: plat(naam) });
    });

    /* Losse woorden uit alle namen, zodat "sampoo" ook aanslaat als de soort
       "Shampoo & conditioner" heet en "brillianz" op "Color Brillianz". */
    lijst.doelen.concat(lijst.woorden).forEach(function (item) {
      item.plat.split(' ').forEach(function (woord) {
        if (woord.length < 4) return;
        if (lijst.woorden.some(function (w) { return w.plat === woord; })) return;
        lijst.woorden.push({ naam: woord, plat: woord });
      });
    });

    (bron.regels || '').split(/[\n;]/).forEach(function (regel) {
      var delen = regel.split('=');
      if (delen.length < 2) return;
      var doelwoord = delen[1].trim();
      if (!doelwoord) return;
      delen[0].split(',').forEach(function (sleutel) {
        var k = plat(sleutel);
        if (k) lijst.regels[k] = doelwoord;
      });
    });

    return lijst;
  }

  function beste(platTerm, kandidaten, max) {
    var grens = toegestaan(platTerm, max);
    var winnaar = null;
    var winst = grens + 1;
    for (var i = 0; i < kandidaten.length; i++) {
      var item = kandidaten[i];
      if (item.plat === platTerm) return item;
      if (grens === 0) continue;
      var d = tikfouten(platTerm, item.plat, grens);
      if (d <= grens && d < winst) {
        winst = d;
        winnaar = item;
      }
    }
    return winnaar;
  }

  /* De verbeterde term, of null als er niets te verbeteren valt. */
  function verbeterTerm(term) {
    var d = voorbereid();
    var platte = plat(term);
    if (!platte) return null;

    if (d.regels[platte]) return d.regels[platte];

    var alles = d.doelen.concat(d.woorden);

    // Eerst de hele term als één naam: "long strong" hoort bij één lijn.
    var treffer = beste(platte, alles, d.max);
    if (treffer && treffer.naam !== term) return treffer.naam;

    // Anders woord voor woord: "keune sampoo" wordt "keune shampoo".
    var woorden = platte.split(' ');
    if (woorden.length < 2) return null;

    var veranderd = false;
    var nieuw = woorden.map(function (woord) {
      if (d.regels[woord]) {
        veranderd = true;
        return d.regels[woord];
      }
      if (woord.length < 5) return woord;
      var hit = beste(woord, alles, d.max);
      if (hit && plat(hit.naam) !== woord) {
        veranderd = true;
        return hit.naam;
      }
      return woord;
    });

    return veranderd ? nieuw.join(' ') : null;
  }

  /* Een merk of collectie met een eigen pagina. Alleen bij een echte
     overeenkomst: de getypte tekst is de naam, of het begin ervan en dan
     hoogstens een paar letters korter.

     Die laatste grens is er met reden. Zonder die grens stuurde "shampoo" de
     bezoeker naar "Shampoo Beschadigd Haar" — dat begint met de zoekterm, maar
     het is een veel smallere categorie dan bedoeld. */
  function zoekDoel(term) {
    var d = voorbereid();
    var p = plat(term);
    if (p.length < 3) return null;

    /* Eerst de eigen regels. Die zijn met de hand geschreven, dus ze gelden
       ook als de zoekopdracht wél resultaten oplevert: wie "long strong" typt
       wil naar die lijn, niet naar een lijst waar hij hem tussen moet zoeken.
       Bij de tikfoutcorrectie ligt dat anders — die raadt, en raden mag alleen
       als er anders niets was. */
    if (d.regels[p]) p = plat(d.regels[p]);

    var exact = null;
    var begin = null;
    d.doelen.forEach(function (doel) {
      if (!doel.url) return;
      if (doel.plat === p) {
        exact = exact || doel;
        return;
      }
      if (!begin && p.length >= 5 && doel.plat.indexOf(p) === 0 && doel.plat.length - p.length <= 3) {
        begin = doel;
      }
    });
    return exact || begin;
  }

  window.ncZoekPlat = plat;
  window.ncZoekTerm = verbeterTerm;
  window.ncZoekDoel = zoekDoel;
})();
